import util from '../util.js';
var moment = require('moment');
var _ = require('lodash');

var Promise = util.getPromise();
var IntervalTree = util.getIntervalTree();


/**
 * mutations commit changes to state
 * @module mutations
 */
export default {

    /**
     * sets the events property on states
     * @param {object} events - the events to set into state
     */
    setEvents(state, events) {
        return new Promise((resolve) => {
            state.events = _.keyBy(events, 'id');
            resolve(true);
        });
    },

    /**
     * sets the date ordered list of events
     * @param {object} events - the events which are to be ordered
     */
    setDateOrderEvents(state) {
        // used to sort events in date ascending order
        let compareEventStarts = (a, b) => {
            return moment(a['start_date']).isBefore(moment(b['start_date'])) ?
                -1 :
                1;
        }

        state.dateOrderEvents = _.map(
            _.toArray(state.events).sort(compareEventStarts),
            util.getEventId
        )
    },

    /**
     * sets the name ordered list of events
     * @param {object} events - the events which are to be ordered
     */
    setNameOrderEvents(state) {
        // used to sort events in ascending name order
        let compareEventNames = (a, b) => {
            return a['name'].localeCompare(b['name']);
        };

        state.nameOrderEvents = _.map(
            _.toArray(state.events).sort(compareEventNames),
            util.getEventId
        )
    },

    /**
     * sets the current requested url
     * @param {string} requestedUrl - the 'url' part of the url,
     *                                that is to say, the part of
     *                                the url after /view/
     */
    setCurrentEventUrl(state, requestedUrl) {
        state.currentSingleEventUrl = requestedUrl;
    },

    /**
     * sets the current single event to match the url
     */
    setCurrentEvent(state) {

        // find the event with the url that matches the current url
        state.currentSingleEvent = _.toArray(state.events).find(eventCheck => {
            return eventCheck['url'] === state.currentSingleEventUrl;
        });
    },


    /**
     * forces the state of the current single event in state
     * @param {object} payload.
     * @param {object} payload.eventData the data for the current event.
     */
    forceCurrentEventData(state, payload) {
        state.currentSingleEvent = payload.eventData;
    },

    setModules(state, payload) {
        state.modules = _.keyBy(payload.modules, 'code');
    },


    /**
     * resets the module interval tree
     */
    resetModuleIntervalTree(state) {
        state.moduleIntervalTree = new IntervalTree();
    },


    /**
     * resets the event date order module modules
     */
    resetCurrentEventDateOrderModules(state) {
        state.modulesByDate = {};
    },


    /**
     * sets the moduleDayDateOrder property on state, ordering
     * the days on which modules occur
     */
    setModuleDayDateOrder(state) {
        state.moduleDayDateOrder = _(state.modules)
            .map('start_date')  // get each module's start date
            .uniq()             // we only want unique values
            .sortBy((a, b) => { // sort them in ascending order
                let aMoment = moment(a, state.dateFormat);
                let bMoment = moment(b, state.dateFormat);
                return aMoment.isAfter(bMoment) ? 1 : -1;
            })
            .value()
    },


    /**
     * sets the pairing of date strings with their ordered modules into state
     */
    setDateModules(state) {
        state.dateModules = _(state.modules)
            .groupBy(module_ => module_['start_date'])
            .mapValues(moduleArray => {
                return moduleArray.sort((a, b) => {
                    let aTime = moment(a, state.timeFormat);
                    let bTime = moment(b, state.timeFormat);
                    return aTime.isAfter(bTime) ? 1 : -1;
                });
            })
            .value()
    },


    /**
     * updates the last loaded event to the current event,
     * should only be called once an event is finished loading
     */
    setLastLoadedEvent(state) {
        state.lastLoadedEvent = state.currentSingleEvent.id;
    },


    /**
     * sets the currently selected modules
     * @param {object} modules - the currently selected modules
     */
    setSelectedModules(state, modules) {
        console.log('setting selected module to ' + modules)
        console.dir(modules)
        state.selectedModules = modules;
    },


    /**
     * sets the currently clasing selected modules
     * TODO: make this a little nicer to work with
     */
    setClashingModules(state) {

        let moduleClashTree = new IntervalTree(0);

        /*
         * we use this to create an object such that:
         * moduleId: [{clashData}, {clashData}, ... ]
         */
         
        // First populate the interval tree
        state.selectedModules.map(module_ => {                             // iterate over each code, getting the clashes for each
            let moduleData = state.modules[module_];                       // get the actual object for the module

            let dateTimeData = util.getModulesCombinedStartEndDateTimes(   // get the unix time for start and end
                moduleData,
                state.dateFormat,
                state.timeFormat
            );

            // each event brings with it its own data on which modules
            // within that event will clash
            const eventModuleData = state.currentSingleEvent['event_modules']
              .filter(m => m.module === module_)[0]

            // we use the data brought with the event to check
            // for clashes; the data from the module alone cannot
            // be used to check whether the module can clash or not,
            // as this varies by event.
            if (eventModuleData.clashing) {
              console.log(`${module_} is a clasher`)
              moduleClashTree.add(                                           // add this module to the tree
                  dateTimeData.start,
                  dateTimeData.end - 1,  // -1 so Something ending at 1:00 doesn't clash with something beginning at 1:00, e.g. [s, e] => [s, e)
                  module_
              )
            }
        })
         
        // Then generate and return a clash list.  It was done all as one step before, but that left only one-way clashes
        state.clashingModules = _.zipObject(                                   // zipObject allows us to set keys and values
            state.selectedModules,                                             // use the selectedModules as keys

           
            state.selectedModules.map(module_ => {                             // iterate over each code, getting the clashes for each
                let moduleData = state.modules[module_];                       // get the actual object for the module

                let dateTimeData = util.getModulesCombinedStartEndDateTimes(   // get the unix time for start and end
                    moduleData,
                    state.dateFormat,
                    state.timeFormat
                );

                // each event brings with it its own data on which modules
                // within that event will clash
                const eventModuleData = state.currentSingleEvent['event_modules']
                  .filter(m => m.module === module_)[0]

                let clashes = null;
                // Search for clashing modules (if this is a clashing module)                
                if (eventModuleData.clashing) {
                    clashes = moduleClashTree.search(                          // see if this module clashes with anything already in the tree
                        dateTimeData.start,
                        dateTimeData.end - 1
                    );
                } 
                
                // Since we test for clashes after building the tree, we need to exclude self-clashes
                return _.filter(
                    _.map(                                                  // we only want the id's
                        clashes,
                        clashData => clashData.id
                    ), module_code => module_code != module_
                )
            })
        )
    },


    /**
     * sets the firstname value in state
     * @param {string} firstname - the name to be set into state.
     */
    setFirstname(state, firstname) {
        state.firstname = firstname;
    },


    /**
     * sets the surname value in state
     * @param {string} surname - the name to be set into state.
     */
    setSurname(state, surname) {
        state.surname = surname;
    },


    /**
     * sets the email value in state
     * @param {string} email - the email to be set into state.
     */
    setEmail(state, email) {
        state.email = email;
    },


    /**
     * sets the postcode value in state
     * @param {string} postcode - the postcode to be set into state.
     */
    setPostcode(state, postcode) {
        state.postcode = postcode;
    },


    /**
     * sets the state of dataProtection in state
     * @param {bool} dataProtection - the state of the dataProtection to be set into state.
     */
    setDataProtection(state, dataProtection) {
        state.dataProtection = dataProtection;
    },

    /**
     * sets the state of emailOptin in state
     * @param {bool} emailOptin - the state of the emailOptin to be set into state.
     */
    setEmailOptin(state, emailOptin) {
        state.emailOptin = emailOptin;
    },

    /**
     * sets the state of overEighteenOptin in state
     * @param {bool} overEighteenOptin - the state of the overEighteenOptin to be set into state.
     */
    setOverEighteenOptin(state, overEighteenOptin) {
        state.overEighteenOptin = overEighteenOptin;
    },

    /**
     * sets the state of highestQualification in state
     * @param {string} highestQualification - the state of the highestQualification to be set into state.
     */
    setHighestQualification(state, highestQualification) {
        state.highestQualification = highestQualification;
    },

     /**
     * sets the state of divisionalInformation in state
     * @param {string} divisionalInformation - the state of the divisionalInformation to be set into state.
     */
    setDivisionalInformation(state, divisionalInformation) {
        state.divisionalInformation = divisionalInformation;
    },

     /**
     * sets the state of currentStudyProgramme in state
     * @param {string} currentStudyProgramme - the state of the currentStudyProgramme to be set into state.
     */
    setCurrentStudyProgramme(state, currentStudyProgramme) {
        state.currentStudyProgramme = currentStudyProgramme;
    },


    /**
     * removes all selected modules
     */
    clearSelectedModules(state) {
        state.selectedModules = [];
    },

    /**
     * sets data on the registration state of modules
     */
    setRegisteredStatus(state, payload) {
        console.log('setting registered to: ');
        console.dir(payload);
        state.registered = {
            event: payload['registered_event'],
            modules: payload['registered_modules'],
        };
    }

}



// WEBPACK FOOTER //
// ./src/store/mutations.js